import "./Minecraft_Button.css"

import {Link} from "react-router-dom"

function MinecraftButton({to, label}) {

    return (

        <Link className="button" to={to}>{label}</Link>

    )

}

export default MinecraftButton;